module.exports = __webpack_public_path__ + "static/img/mxbt_jkjx_icon.png";